import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogBody, DialogActions } from './dialog';
import { Button } from './button';
import { Field, Label } from './fieldset';
import FileReceiver from './FileReceiver';
import { DocumentIcon, XMarkIcon } from '@heroicons/react/24/outline';

// Direct (link-free) contract upload for a cliente. The parent does the
// upload; this dialog only collects the PDF and shows the error, if any.
const ClienteContractDialog = ({ isOpen, onClose, onSubmit, loading, error }) => {
  const [contractFile, setContractFile] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!contractFile) return;
    const ok = await onSubmit({ contractFile });
    if (ok) setContractFile(null);
  };

  const handleClose = () => {
    setContractFile(null);
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Nuevo Contrato</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogBody>
          <Field>
            <Label>Contrato (PDF)</Label>
            {contractFile ? (
              <div className="flex items-center gap-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                <DocumentIcon className="h-5 w-5 text-green-600 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-green-800 truncate">
                    {contractFile.name}
                  </p>
                  <p className="text-xs text-green-600">
                    {(contractFile.size / 1024).toFixed(0)} KB
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => setContractFile(null)}
                  className="p-1 rounded-full hover:bg-green-100 transition-colors"
                >
                  <XMarkIcon className="h-4 w-4 text-green-600" />
                </button>
              </div>
            ) : (
              <FileReceiver
                title="Arrastra o selecciona el contrato"
                type="pdf"
                maxFiles={1}
                onFilesChange={(files) => {
                  if (files && files.length > 0) {
                    setContractFile(files[0]);
                  }
                }}
              />
            )}
          </Field>
          {error && (
            <p className="mt-3 text-sm text-red-600">{error}</p>
          )}
        </DialogBody>
        <DialogActions>
          <Button plain onClick={handleClose} type="button">
            Cancelar
          </Button>
          <Button type="submit" disabled={!contractFile || loading}>
            {loading ? 'Subiendo...' : 'Subir Contrato'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ClienteContractDialog;
